

<mat-card appearance="outlined" class="mat-elevation-z8" >
    <div>
        <div class="spinner-container-local" *ngIf="loadingComponents">
            <mat-spinner class="content-box"></mat-spinner>
        </div>
    </div>
    <div *ngIf="!loadingComponents">

        <div class="header">
            <div class="txt warning-message" *ngIf="notDownloadedDocuments">
                {{'historyTexts.notSignedDocs' | translate}}
            </div>
        </div>
    
        <div *ngFor="let doc of downloads | slice:0:5;" class="file-container">
            <div class="download">
                <button  mat-mdc-icon-button color="primary" matTooltip="{{'historyTexts.downloadDocument' | translate}}"
                    (click)="downloadFile(doc)">
                    <cqes-icon icon="file_download" class="download-icon"></cqes-icon>
                </button>
            </div>
            <div class="label">
                <span>
                    <strong>
                        {{doc.displayedText}} &nbsp;
                    </strong>
                </span>
            </div>
        </div>

        <mat-expansion-panel *ngIf="downloads.length > 5" (opened)="panelOpenState = true"
            (closed)="panelOpenState = false">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    {{ (panelOpenState ? 'historyTexts.hide' : 'historyTexts.showMore') | translate }}
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div *ngFor="let doc of downloads | slice:5:downloads.length;" class="file-container more-docs">
                <div class="download">
                    <button mat-mdc-icon-button color="primary" matTooltip="{{'historyTexts.downloadDocument' | translate}}"
                        (click)="downloadFile(doc)">
                        <cqes-icon icon="file_download" [color]="red" class="download-icon"></cqes-icon>
                    </button>
                </div>
                <div class="label">
                    <strong>
                        {{doc.displayedText}} &nbsp;
                    </strong>
                </div>
            </div>
        </mat-expansion-panel>
    </div>

    <div class="txt warning-message" *ngIf="!validCertificates">
        <strong>{{'historyTexts.noValidCerts' | translate}}</strong>
    </div>

    <mat-card-content class="container">
        <mat-horizontal-stepper *ngIf="validCertificates" linear #stepper="matHorizontalStepper" class="row">
            <ng-template matStepperIcon="done">
                <cqes-icon icon="check"></cqes-icon>
            </ng-template>
            <ng-template matStepperIcon="edit">
                <cqes-icon icon="check"></cqes-icon>
            </ng-template>
            <mat-step [completed]="signingStepCompleted" class="col-3" [editable]="isEditable">
                <div class="txt sign-label" *ngIf="!file">
                    <strong>{{'signingTexts.info.chooseFile' | translate}}</strong>
                </div>

                <div class="row">
                    <div class="col-md-6">
                        <div class="file-contents">
                            <form [formGroup]="fileForm" novalidate>
                                <ng-template matStepLabel>{{texts.chooseFile}}</ng-template>
                                <!-- choose file for signing -->
                                <input type="hidden" name="certReqId" value="selectedCert?.certReqId" />
                                <button mat-raised-button (click)="info.endWait(); fileInput.click()"
                                    [matTooltip]="texts.chooseFile" [disabled]="isCertInvalid">
                                    <cqes-icon icon="file_upload" class="upload"></cqes-icon>
                                    {{texts.chooseFile}}
                                </button>
                                <p *ngIf="!file" class="max-size">{{texts.info.maxSizeDocInfo}}</p>
                                <input type="file" id="file" #fileInput (change)="onFileChanged($event)" />
                                <ng-template matStepLabel matStepperIcon="done">
                                    <cqes-icon icon="check"></cqes-icon>
                                </ng-template>
                            </form>
                            <div *ngIf="file" class="txt">
                                <mat-chip-listbox>  
                                    <mat-chip-option color="primary">{{texts.info.fileName}}
                                        <strong>: {{file?.name}}</strong>
                                    </mat-chip-option>
                                    <mat-chip-option color="accent">{{texts.info.fileSize}}
                                        <strong>: {{file?.size | filesize}}</strong>
                                    </mat-chip-option>
                                </mat-chip-listbox>
                            </div>
                            <ng-template matStepLabel>{{texts.chooseFile}}</ng-template>

                            <mat-checkbox [(ngModel)]="otherSigner">
                                {{ 'signingTexts.otherSigner' | translate }} </mat-checkbox>
                            <div class="txt search-container" *ngIf="otherSigner">
                                <div>
                                    <strong>{{'signingTexts.info.chooseUsers' | translate}}</strong>
                                </div>
                                <mat-form-field class="search-input">
                                    <input matInput placeholder="{{'signingTexts.info.addReceiver' | translate}}"
                                        [(ngModel)]="userIdentifier" (keydown.enter)="searchUser()">
                                </mat-form-field>

                                <button class="search-button" mat-raised-button color="accent" (click)="searchUser()">
                                    {{'signingTexts.info.add' | translate}}
                                </button>
                                <button class="search-button" mat-raised-button color="accent" (click)="addSelf()">
                                        {{'signingTexts.info.addSelf' | translate}}
                                </button>
                                <div class="identifier-format-instructions">
                                    <i *ngIf="users.length==0">
                                        {{'signingTexts.userIdentifierFormat' | translate}}
                                    </i>
                                    <mat-chip-listbox *ngIf="users.length > 0">
                                        <div class="chip-container">
                                            <mat-chip-option color="primary" *ngFor="let user of users">
                                                <div class="name">
                                                    <strong>
                                                        {{displayUserName(user.cmrId)}}
                                                    </strong>

                                                </div>

                                                <cqes-icon class="chip-icon" icon="cancel"
                                                    (click)="removeSigner(user.cmrId)"></cqes-icon>
                                            </mat-chip-option>
                                        </div>
                                    </mat-chip-listbox>
                                </div>
                            </div>
                            <div class="validity-period">
                                <div class="validity-header">
                                    <strong> {{'signingTexts.chooseValidity' | translate}}: </strong>
                                </div>
                                <mat-select placeholder="{{'signingTexts.Validity' | translate}}" name="validity-period" [ngModel]="validity">
                                <mat-option *ngFor="let p of periodsDictionary" (click)="onSelectPeriod(p.value)" [value]="p.value">
                                  {{p.key}}  {{getUnitTranslation(p.key, p.unit)}}
                                </mat-option>
                              </mat-select>
                            </div>
                        </div>
                    </div>

                    <div class="col">
                        <!--advanced form-->
                        <form *ngIf="signTypeForm && texts && file" [formGroup]="signTypeForm" novalidate>
                            <mat-expansion-panel>
                                <mat-expansion-panel-header class="advanced">
                                    <mat-panel-title>
                                        {{texts.info.signatureSettings}}
                                    </mat-panel-title>
                                </mat-expansion-panel-header>
                                <div class="container">
                                    <div class="row con">
                                        <!-- format -->
                                        <mat-form-field class="col-sm-5 col-12">
                                            <mat-select placeholder="{{texts.signFormat}}" formControlName="signFormat"
                                                required (selectionChange)="setTypes($event)">
                                                <mat-option *ngFor="let item of values.signFormat" [value]="item.value">
                                                    {{ item.name }}
                                                </mat-option>
                                            </mat-select>

                                            <cqes-icon icon="info" matSuffix class="info-icon-tool" matTooltipClass="mat-tooltip-widе"
                                                matTooltip="{{'signingTexts.info.cades' | translate}}&#13;{{'signingTexts.info.pades' | translate}}&#13;{{'signingTexts.info.xades' | translate}}">
                                            </cqes-icon>
                                        </mat-form-field>
                                        <!-- sign level -->
                                        <mat-form-field class="col col-sm-5 col-12">
                                            <mat-select placeholder="{{texts.signLevel}}" formControlName="signLevel"
                                                required>
                                                <mat-option *ngFor="let item of values.signLevel" [value]="item.value">
                                                    {{ item.name }}
                                                </mat-option>
                                            </mat-select>
                                            <cqes-icon icon="info" matSuffix class="info-icon-tool" matTooltipClass="mat-tooltip-widе"
                                                matTooltip="{{'signingTexts.info.levelInfo' | translate}}">
                                            </cqes-icon>
                                        </mat-form-field>
                                    </div>

                                    <div class="row">
                                        <!-- type of signature -->
                                        <mat-form-field class="col col-sm-5 col-12">
                                            <cqes-icon icon="info" matSuffix class="info-icon-tool" matTooltipClass="mat-tooltip-widе"
                                                matTooltip="{{'signingTexts.info.typeInfo' | translate}}">
                                            </cqes-icon>
                                            <mat-select placeholder="{{texts.signType}}" formControlName="signType"
                                                required>
                                                <mat-option *ngFor="let item of values.signType" [value]="item.value">
                                                    {{ item.name }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                        <!-- hash algo -->
                                        <mat-form-field class="col col-sm-5 col-12">
                                            <cqes-icon icon="info" matSuffix class="info-icon-tool"
                                                matTooltip="{{'signingTexts.info.hashInfo' | translate}}">
                                            </cqes-icon>
                                            <mat-select placeholder="{{texts.signHashAlg}}"
                                                formControlName="signHashAlg" required>
                                                <mat-option *ngFor="let item of values.signHashAlg"
                                                    [value]="item.value">
                                                    {{ item.name }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>

                                    </div>
                                    <div class="row" *ngIf="displayToBeArchivedCheckbox()">
                                        <mat-checkbox formControlName="notToBeArchived">
                                            {{ 'signingTexts.notToBeArchived' | translate }} </mat-checkbox>
                                    </div>
                                    <!-- add signature to pdf -->
                                    <div class="row" *ngIf="signTypeForm.value.signFormat === 'PAdES'">
                                        <mat-checkbox formControlName="visibleSignature">
                                            {{ 'signingTexts.visibleSignature' | translate }} </mat-checkbox>
                                    </div>
                                </div>
                            </mat-expansion-panel>
                            <!-- бутона подпиши -->
                            <mat-card-actions class="tar button-holder">
                                <button mat-raised-button color="accent" (click)="sign()">
                                    {{ otherSigner ? texts.info.send  : texts.info.sign }}
                                </button>
                            </mat-card-actions>
                        </form>
                    </div>
                </div>
            </mat-step>
            <mat-step [stepControl]="fileForm" class="col-3">
                <form [formGroup]="fileForm" novalidate>
                    <ng-template matStepLabel>{{texts.signResult}}</ng-template>
                    <div class="result">
                        <div *ngIf="loading">
                            <span *ngIf="!otherSigner">
                                {{texts.info.confirmSigning}}
                            </span>
                            <span *ngIf="otherSigner">
                                {{texts.info.sendForSinging}}
                            </span>
                            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                        </div>
                        <div *ngIf="!loading && !otherSigner">
                            <strong>
                                <span *ngIf="isSignSuccessfully">{{'signingTexts.signingSuccess' | translate}}</span>
                                <span *ngIf="!isSignSuccessfully && !signingCancelled"
                                    class="error">{{'signingTexts.signingError' | translate}}</span>
                                <span *ngIf="signingCancelled"
                                    class="error">{{'signingTexts.signingCancelled' | translate}}</span>
                            </strong>
                            <button *ngIf="isSignSuccessfully" [disabled]="loading" mat-button
                                (click)="onDownloadClick()" #link id="download-file-btn">{{'common.download'
                                            | translate}}</button>
                        </div>
                        <div *ngIf="!loading && otherSigner">
                            <strong>
                                <span *ngIf="sendSuccess">{{'signingTexts.signingSendSuccess' | translate}}</span>
                                <span *ngIf="!sendSuccess"
                                    class="error">{{'signingTexts.signingSendError' | translate}}</span>
                            </strong>
                        </div>
                    </div>
                </form>
                <mat-card-actions class="tar">
                    <button [disabled]="loading" mat-raised-button matStepperPrevious (click)="info.endWait()">{{'common.back'
                                    | translate}}</button>
                </mat-card-actions>
            </mat-step>
        </mat-horizontal-stepper>
    </mat-card-content>
</mat-card>